import type { ToolDefinition, ToolId } from '../../types/tool-registry.js';
import { pilotTools } from './seed/tools.js';
import { approvalRoot } from './seed/approvalRoot.js';
import { receiptDocument } from './seed/receiptDocument.js';
import { oracleDocument } from './seed/oracleDocument.js';
import { assertPinnedEverydayHealthApprovalIntegrity } from './everyday-health-trust.js';
import { canonicalRegistryJson } from './canonical.js';
import { TOOL_REGISTRY_CANONICAL_EXACT108_TOOL_IDS } from './registry-constants.js';

export { canonicalRegistryJson, canonicalUnsignedToolRegistryPointer } from './canonical.js';

function deepFreeze<T>(value: T): T {
    if (value !== null && typeof value === 'object' && !Object.isFrozen(value)) {
        const children: readonly unknown[] = Object.values(value);
        children.forEach(child => deepFreeze(child));
        Object.freeze(value);
    }
    return value;
}

assertPinnedEverydayHealthApprovalIntegrity(approvalRoot, receiptDocument, oracleDocument);
const everydayToolIds: readonly ToolId[] = ['lpg-payback', 'fuel-consumption', 'profit-margin', 'basal-metabolic-rate', 'historical-ideal-weight-reference'];
const everydayHealthTools = pilotTools.filter(tool => everydayToolIds.includes(tool.toolId));
if (everydayHealthTools.some(tool => {
    const approved = receiptDocument.tools.find(record => record.runtimeToolId === tool.toolId);
    const oracle = oracleDocument.records.find(record => record.runtimeToolId === tool.toolId);
    const { testVectors, ...actualContract } = tool;
    return approved === undefined || oracle === undefined
        || canonicalRegistryJson(actualContract) !== canonicalRegistryJson(approved.contract)
        || canonicalRegistryJson(testVectors.cases) !== canonicalRegistryJson(oracle.cases);
})) {
    throw new Error('Günlük/sağlık assembled descriptor ve içerik imzalı approval receipt ile eşleşmiyor.');
}
if (everydayHealthTools.length !== everydayToolIds.length || everydayHealthTools.some((tool, index) => tool.toolId !== everydayToolIds[index])) {
    throw new Error('Günlük/sağlık production araç sırası exact5 sözleşmesiyle eşleşmiyor.');
}

const browserPilotTools = deepFreeze(pilotTools);
if (browserPilotTools.length !== TOOL_REGISTRY_CANONICAL_EXACT108_TOOL_IDS.length
    || browserPilotTools.some((tool, index) => tool.toolId !== TOOL_REGISTRY_CANONICAL_EXACT108_TOOL_IDS[index])) {
    throw new Error('Tarayıcı tool registry kanonik Exact108 kimlik/sıra bütünlüğüyle eşleşmiyor.');
}

export function getBrowserBundledPilotTools(): readonly ToolDefinition[] {
    return browserPilotTools;
}

export function getBrowserBundledPilotTool(toolId: ToolId): ToolDefinition | undefined {
    return browserPilotTools.find(tool => tool.toolId === toolId);
}
